import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  private genericService = inject(GenericService);
  private router = inject(Router);

  currencyName = 'OCurrency';

  currentCurrency = signal<string>(
    localStorage.getItem(this.currencyName) || 'EUR'
  );

  private readonly symbols: Record<string, string> = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    EGP: 'ج.م',
    SAR: '﷼',
    AED: 'د.إ',
  };

  transform(currencyCode?: string): string {
    if (!currencyCode) return '';
    return this.symbols[currencyCode.toUpperCase()] ?? currencyCode;
  }

  setCurrency(currency: string) {
    this.currentCurrency.set(currency);
    localStorage.setItem(this.currencyName, currency);
  }

  getAllCurrencies(): Observable<any[]> {
    return this.genericService.get<any[]>('currency');
  }

  getCurrencyByCode(code: string): Observable<any> {
    return this.genericService.get<any>(`currency/${code}`);
  }
}
